export default __webpack_public_path__ + "static/media/lovelockdown-artworkinfo4.82130bfc.png";